import { BonusSettlementDetailSidebarReducerState } from './bonus-settlements-supplier-detail-sidebar-reducer';

export const SIDEBAR_UPDATE = 'SIDEBAR_UPDATE';

export const sidebarUpdate = (settings: BonusSettlementDetailSidebarReducerState) => {
    return {
        type: SIDEBAR_UPDATE,
        settings,
    };
};
